import React from 'react';
import HBox from '../HBox';
import ex from 'utils/ex';
import FocusableButton from '../FocusableButton';

const MIN_PAGE = 1;
export default function PagingIndicator(props) {
  const {
    indicatorCount = 5,
    maxPage,
    page,
    onNPage,
    renderPrevButtons,
    renderNextButtons,
    ...rest
  } = props || {};
  const halfCount = React.useMemo(() => Math.ceil(indicatorCount / 2), [indicatorCount]);
  const array = React.useMemo(() => Array.from({ length: indicatorCount }), [indicatorCount]);
  const isFirst = React.useMemo(() => page <= halfCount, [halfCount, page]);
  const isLast = React.useMemo(() => maxPage < page + halfCount, [maxPage, page, halfCount]);
  const initial = isFirst ?
    1 :
    isLast ?
      Math.max(MIN_PAGE, maxPage - indicatorCount + 1) :
      Math.max(MIN_PAGE, page - halfCount + 1);
  const prevButtons = React.useMemo(() => renderPrevButtons({ page, onNPage, isFirst, isLast, initial, indicatorCount, halfCount, maxPage }), [halfCount, indicatorCount, initial, isFirst, isLast, maxPage, onNPage, page, renderPrevButtons]);
  const nextButtons = React.useMemo(() => renderNextButtons({ page, onNPage, isFirst, isLast, initial, indicatorCount, halfCount, maxPage }), [halfCount, indicatorCount, initial, isFirst, isLast, maxPage, onNPage, page, renderNextButtons]);
  if (maxPage <= 1) return null;
  return (
    <HBox {...ex('PagingIndicator', rest)} full>
      {prevButtons}
      {array.map((_, index) => {
        const p = initial + index;
        if (maxPage < p) return null;
        if (p < MIN_PAGE) return null;
        return (
          <FocusableButton
            key={p}
            {...ex(['PagingIndicatorButton', 'PagingIndicatorNoButton', { selected: p === page }], {
              onClick: () => onNPage(p),
            })}
          >
            {p}
          </FocusableButton>
        )
      })}
      {nextButtons}
    </HBox>
  );
}